<template>
  <Toast />
  <InformationBasic :immatriculation="immatriculation" :marqueAfficher="marqueAfficher" :modeleAfficher="modeleAfficher"
    :annee="annee" :isDataLoading="isDataLoading" />
  <InformationSupplementaire :confidentialiteAfficher="confidentialiteAfficher"
    :creerParDescription="creerParDescription" :creerPar="creerPar" :creerLe="creerLe" :particularites="particularites"
    :provinceAfficher="provinceAfficher" :siteAfficher="siteAfficher" :isDataLoading="isDataLoading" />
  <ButtonBar :actionAccesDecision="actionAccesDecision" @auditModifications="auditModifications"
             @fermer="fermer" @auditAcces="auditAcces" @modifier="modifier" />
  <LiaisonsModule :isModifier="false" :genre="'VE'"/>
</template>

<script>
import ButtonBar from '../../components/Commun/ButtonBarConsulter.vue'
import InformationBasic from '../../components/vehicule/Consulter/InformationBasic.vue'
import InformationSupplementaire from '../../components/vehicule/Consulter/InformationSupplementaire.vue'
import LiaisonsModule from '../../components/Commun/LiaisonsModule.vue'
import axios from 'axios';
import {mapGetters} from 'vuex';

export default {
  name: "vehiculeConsulter",
  components: {
    InformationBasic,
    InformationSupplementaire,
    LiaisonsModule,
    ButtonBar,
  },
  beforeMount() {
    this.$root.$refs.breadcrumbComp.source.nom = 'vehicule';
    this.$root.$refs.breadcrumbComp.source.genre = 'VE';
  },       
  mounted() {
    this.isDataLoading = true;
    this.$root.$refs.breadcrumbComp.ajout("Consulter Véhicule");
    axios.defaults.headers.common["cleProfil"] = this.profil.cle;
    this.getVehicule();
  },
  computed: {
    ...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil',
      actionAccesDecision: 'vehicule/actionAccesDecision'
    })
  },
  data() {
    return {    
      isDataLoading: false,
      annee: "",
      cle: null,
      confidentialiteAfficher: "",
      creerLe: null,
      creerPar: "",
      creerParDescription: "",
      dateCreation: "",
      immatriculation: "",
      marqueAfficher: "",
      modeleAfficher: "",
      particularites: null,
      provinceAfficher: "",
      site: null,
      siteAfficher: "",
    };
  },
  methods: {
    assignerVehicule(res) {
      this.annee = res.data.entite.annee;
      this.confidentialiteAfficher = res.data.entite.confidentialiteAfficher;
      this.creerLe = this.$commun.formatDateHeure(res.data.entite.creerLe);
      this.creerParDescription = res.data.entite.creerParDescription;
      this.creerPar = res.data.entite.creerPar;
      this.dateCreation = res.data.entite.dateCreation;
      this.immatriculation = res.data.entite.immatriculation;
      this.marqueAfficher = res.data.entite.marqueAfficher;
      this.modeleAfficher = res.data.entite.modeleAfficher;
      this.particularites = res.data.entite.particulariteAfficher;
      this.provinceAfficher = res.data.entite.provinceAfficher;
      this.siteAfficher = res.data.entite.siteAfficher;
    },
    getVehicule() {
      this.$store
        .dispatch("vehicule/consulterAction", {
          cle: this.$route.params.cle,
          site: this.$route.params.site
        })
        .then((res) => {
          this.assignerVehicule(res);
          this.isDataLoading = false;
        });
    },
    modifier() {
      this.$router.push({
        name: "vehiculeModifier",
        params: {
          cle: this.$route.params.cle,
          site: this.$route.params.site,
        },
      });
    },
    auditAcces() {
      this.$router.push({
        name: "vehiculeAuditAcces",
        params: {
          cle: this.$route.params.cle,
          site: this.$route.params.site
        },
      });
    },
    auditModifications() {
      this.$router.push({
        name: "vehiculeAuditModifications",
        params: {
          cle: this.$route.params.cle,
          site: this.$route.params.site
        },
      });
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
  },
  watch: {
    '$route.params': function (nouveaux, anciens) {
      if ((this.$route.name === "vehiculeConsulter")
        && nouveaux.cle
        && (nouveaux.cle !== anciens.cle)) {
        location.reload()
      }
    }
  },
};
</script>